import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
// import { motion, AnimatePresence } from 'framer-motion'; // Removed for static content
import { X, ChevronLeft, ChevronRight, Camera } from 'lucide-react';

const Gallery = () => {
  const { t } = useTranslation();
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [filter, setFilter] = useState('all');

  const images = [
    { src: '/images/WechatIMG182.jpg', alt: 'Pacific 91 Restaurant Interior', category: 'interior' },
    { src: '/images/WechatIMG183.jpg', alt: 'Pacific 91 Dining Area', category: 'interior' },
    { src: '/images/WechatIMG184.jpg', alt: 'Pacific 91 Buffet', category: 'food' },
    { src: '/images/WechatIMG185.jpg', alt: 'Pacific 91 Cuisine', category: 'food' },
    { src: '/images/WechatIMG187.jpg', alt: 'Pacific 91 Service', category: 'service' },
    { src: '/images/WechatIMG188.jpg', alt: 'Pacific 91 Team', category: 'service' },
    { src: '/images/WechatIMG189.jpg', alt: 'Pacific 91 Food Display', category: 'food' },
    { src: '/images/WechatIMG191.jpg', alt: 'Pacific 91 Specialties', category: 'food' },
    { src: '/images/WechatIMG192.jpg', alt: 'Pacific 91 Dishes', category: 'food' },
    { src: '/images/WechatIMG193.jpg', alt: 'Pacific 91 Atmosphere', category: 'interior' },
    { src: '/images/WechatIMG194.jpg', alt: 'Pacific 91 Main View', category: 'interior' },
    { src: '/images/WechatIMG195.jpg', alt: 'Pacific 91 Design', category: 'interior' },
    { src: '/images/WechatIMG196.jpg', alt: 'Pacific 91 Experience', category: 'food' }
  ];

  const openModal = (image, index) => {
    setSelectedImage(image);
    setCurrentIndex(index);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  const nextImage = () => {
    const newIndex = (currentIndex + 1) % images.length;
    setCurrentIndex(newIndex);
    setSelectedImage(images[newIndex]);
  };

  const prevImage = () => {
    const newIndex = (currentIndex - 1 + images.length) % images.length;
    setCurrentIndex(newIndex);
    setSelectedImage(images[newIndex]);
  };


  return (
    <div className="gallery">
      <section className="gallery-hero section">
        <div className="gallery-header">
          <Camera className="header-icon" />
          <h1>{t('gallery.title')}</h1>
          <p>{t('gallery.subtitle')}</p>
          
          {/* Filter buttons */}
          <div className="filter-buttons">
            <button 
              className={`filter-btn ${filter === 'all' ? 'active' : ''}`}
              onClick={() => setFilter('all')}
            >
              Toutes
            </button>
            <button 
              className={`filter-btn ${filter === 'interior' ? 'active' : ''}`}
              onClick={() => setFilter('interior')}
            >
              Intérieur
            </button>
            <button 
              className={`filter-btn ${filter === 'food' ? 'active' : ''}`}
              onClick={() => setFilter('food')}
            >
              Cuisine
            </button>
            <button 
              className={`filter-btn ${filter === 'service' ? 'active' : ''}`}
              onClick={() => setFilter('service')}
            >
              Service
            </button>
          </div>
        </div>
      </section>


      {/* Image Grid */}
      <section className="images-section section"
      >
        <div className="images-grid">
            {images
              .filter(img => filter === 'all' || img.category === filter)
              .map((image, index) => (
              <div
                key={image.src}
                className="image-card"
                onClick={() => openModal(image, index)}
              >
                <img src={image.src} alt={image.alt} />
                <div className="image-overlay">
                  <div className="overlay-content">
                    <h3>{image.alt}</h3>
                    <p>{t('gallery.clickToEnlarge')}</p>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </section>

      {/* Modal */}
        {selectedImage && (
          <div 
            className="modal-overlay"
            onClick={closeModal}
          >
            <div 
              className="modal-content"
              onClick={(e) => e.stopPropagation()}
            >
              <button className="modal-close" onClick={closeModal}>
                <X size={24} />
              </button>
              
              <button className="modal-nav prev" onClick={prevImage}>
                <ChevronLeft size={24} />
              </button>
              
              <img src={selectedImage.src} alt={selectedImage.alt} />
              
              <button className="modal-nav next" onClick={nextImage}>
                <ChevronRight size={24} />
              </button>
            </div>
          </div>
        )}

      <style jsx>{`
        .gallery {
          min-height: 100vh;
          overflow-x: hidden;
        }

        .gallery-header {
          text-align: center;
          margin-bottom: 3rem;
        }

        .header-icon {
          color: #64b5f6;
          width: 4rem;
          height: 4rem;
          margin: 0 auto 1rem;
        }

        .gallery-header h1 {
          font-size: 3rem;
          margin-bottom: 1rem;
        }

        .gallery-header p {
          font-size: 1.2rem;
          color: rgba(255, 255, 255, 0.8);
          margin-bottom: 2rem;
        }

        /* Filter buttons */
        .filter-buttons {
          display: flex;
          gap: 1rem;
          justify-content: center;
          flex-wrap: wrap;
        }

        .filter-btn {
          padding: 0.75rem 1.5rem;
          background: rgba(255, 255, 255, 0.1);
          border: 1px solid rgba(255, 255, 255, 0.2);
          border-radius: 30px;
          color: rgba(255, 255, 255, 0.8);
          font-size: 0.95rem;
          cursor: pointer;
          transition: all 0.3s ease;
          backdrop-filter: blur(10px);
          -webkit-backdrop-filter: blur(10px);
        }

        .filter-btn:hover {
          background: rgba(100, 181, 246, 0.2);
          border-color: rgba(100, 181, 246, 0.5);
          color: white;
          transform: translateY(-2px);
        }

        .filter-btn.active {
          background: rgba(100, 181, 246, 0.3);
          border-color: #64b5f6;
          color: white;
          box-shadow: 0 4px 20px rgba(100, 181, 246, 0.3);
        }

        .images-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
          gap: 1.5rem;
          max-width: 1400px;
          margin: 0 auto;
          padding: 0 1rem;
        }

        .image-card {
          position: relative;
          border-radius: 20px;
          overflow: hidden;
          cursor: pointer;
          background: rgba(255, 255, 255, 0.05);
          box-shadow: 0 8px 32px rgba(31, 38, 135, 0.37);
          border: 1px solid rgba(255, 255, 255, 0.2);
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          transform: translateY(0);
          aspect-ratio: 4/3;
        }

        .image-card:hover {
          transform: translateY(-10px) scale(1.02);
          box-shadow: 0 20px 60px rgba(31, 38, 135, 0.5);
          border-color: rgba(100, 181, 246, 0.3);
        }

        .image-card:nth-child(odd) {
          animation: fadeInLeft 0.8s ease-out forwards;
        }

        .image-card:nth-child(even) {
          animation: fadeInRight 0.8s ease-out forwards;
        }

        @keyframes fadeInLeft {
          from {
            opacity: 0;
            transform: translateX(-30px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @keyframes fadeInRight {
          from {
            opacity: 0;
            transform: translateX(30px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        .image-card img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .image-card:hover img {
          transform: scale(1.1);
        }

        .image-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(to top, rgba(0,8,20,0.9) 0%, rgba(0,8,20,0.3) 50%, transparent 100%);
          opacity: 0;
          transition: all 0.3s ease;
          display: flex;
          align-items: flex-end;
          padding: 1.5rem;
          backdrop-filter: blur(2px);
        }

        .image-card:hover .image-overlay {
          opacity: 1;
        }

        .overlay-content h3 {
          color: white;
          font-size: 1.1rem;
          margin-bottom: 0.5rem;
        }

        .overlay-content p {
          color: rgba(255, 255, 255, 0.8);
          font-size: 0.9rem;
          margin: 0;
        }

        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.9);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 2000;
          padding: 2rem;
        }

        .modal-content {
          position: relative;
          max-width: 90vw;
          max-height: 90vh;
          background: rgba(255, 255, 255, 0.1);
          border-radius: 20px;
          overflow: hidden;
          backdrop-filter: blur(20px);
          border: 1px solid rgba(255, 255, 255, 0.2);
          animation: modalSlideIn 0.3s ease-out;
        }

        @keyframes modalSlideIn {
          from {
            opacity: 0;
            transform: scale(0.9);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }

        .modal-content img {
          width: 100%;
          height: auto;
          max-height: 70vh;
          object-fit: contain;
        }

        .modal-close {
          position: absolute;
          top: 1rem;
          right: 1rem;
          background: rgba(0, 0, 0, 0.5);
          border: none;
          border-radius: 50%;
          color: white;
          width: 3rem;
          height: 3rem;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 2001;
          transition: all 0.3s ease;
        }

        .modal-close:hover {
          background: rgba(0, 0, 0, 0.8);
          transform: scale(1.1);
        }

        .modal-nav {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          background: rgba(0, 0, 0, 0.5);
          border: none;
          border-radius: 50%;
          color: white;
          width: 3rem;
          height: 3rem;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.3s ease;
        }

        .modal-nav:hover {
          background: rgba(0, 0, 0, 0.8);
          transform: translateY(-50%) scale(1.1);
        }

        .modal-nav.prev {
          left: 1rem;
        }

        .modal-nav.next {
          right: 1rem;
        }


        /* Masonry layout for larger screens */
        @media (min-width: 768px) {
          .images-grid {
            grid-auto-rows: 250px;
          }
          
          .image-card:nth-child(4n+1) {
            grid-row: span 2;
          }
          
          .image-card:nth-child(4n+3) {
            grid-column: span 2;
          }
        }

        @media (max-width: 768px) {
          .gallery-header h1 {
            font-size: 2.5rem;
          }

          .images-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 1rem;
            padding: 0 0.5rem;
          }
          
          .image-card {
            aspect-ratio: 1;
          }

          .modal-overlay {
            padding: 1rem;
          }

          .modal-nav {
            width: 2.5rem;
            height: 2.5rem;
          }

          .modal-close {
            width: 2.5rem;
            height: 2.5rem;
          }
        }
        
        @media (max-width: 480px) {
          .images-grid {
            grid-template-columns: 1fr;
            gap: 1rem;
          }
          
          .image-card {
            aspect-ratio: 16/9;
          }
          
          .filter-buttons {
            gap: 0.5rem;
          }
          
          .filter-btn {
            padding: 0.5rem 1rem;
            font-size: 0.85rem;
          }
        }
      `}</style>
    </div>
  );
};

export default Gallery; 